var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40538_15529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0583 3.33332H11.6667V2.49999C11.6667 2.04166 11.2917 1.66666 10.8333 1.66666H9.16668C8.70834 1.66666 8.33334 2.04166 8.33334 2.49999V3.33332H6.94168C6.33334 3.33332 5.83334 3.83332 5.83334 4.44166V17.2167C5.83334 17.8333 6.33334 18.3333 6.95001 18.3333H13.05C13.6667 18.3333 14.1667 17.8333 14.1667 17.225V4.44166C14.1667 3.83332 13.6667 3.33332 13.0583 3.33332Z",
    fill: "#039BE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40538_15529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery100);
export default __webpack_public_path__ + "static/media/Battery100.e60bbd523e7e7e125a4570e833cc671d.svg";
export { ForwardRef as ReactComponent };